import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Routes from "./Components/Routes";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { Provider } from "react-redux";
import store from "./Store";
import { SocketContext,socketInstance } from "./Helper/Socket";
import Notiflix from "notiflix";
Notiflix.Loading.init({
  svgColor: "#c16d18", // Set your custom loader color here
  zIndex: 1500,
});



ReactDOM.render(
  <React.StrictMode>
    <SocketContext.Provider value={socketInstance}>
      <Provider store={store}>
        <Routes />
      </Provider>
    </SocketContext.Provider>
  </React.StrictMode>,
  document.getElementById("root")
);
